import type { getGlycerinOrigin } from '.';

export const getGlycerinOriginReturnMock: ReturnType<typeof getGlycerinOrigin> = { origin: 'hash' };
